import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useMediaQuery } from "@mui/material";

export default function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const mqMax425 = useMediaQuery("(max-width:425px)");

  return (
    <Pagination
      color="primary"
      shape="rounded"
      page={page + 1}
      siblingCount={mqMax425 ? 0 : 1}
      boundaryCount={mqMax425 ? 1 : 1}
      size={mqMax425 ? "small" : "medium"}
      count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
      sx={{
        maxWidth: "100%",
        "& .MuiPagination-ul": {
          flexWrap: "wrap",
          justifyContent: "center",
          rowGap: 0.5,
        },
      }}
    />
  );
}
